/**
 * ResponsavelFilial
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponsavelFilialCollection} from '@/model/collection/ResponsavelFilialCollection'

/* TODO: review generated class */
export class ResponsavelFilial extends Resource {
  idFilialPk: number = 0

  cnpjBase: string | null = null

  get $id() {
    return this.idFilialPk
  }
  set $id(val) {
    this.idFilialPk = val
  }

  /**
   * Gets a instance of a given ID of ResponsavelFilial
   */
  async getResponsavelFilial(id: number) {
    return await Request.get(`/admin/responsavel-filial/${id}`)
      .name('getResponsavelFilial')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of ResponsavelFilial
   */
  static async listResponsavelFilial(params: any) {
    return await Request.get(`/admin/responsavel-filial`, {params})
      .name('listResponsavelFilial')
      .as(ResponsavelFilialCollection)
      .getData()
  }

  /**
   * Persists a new instance of ResponsavelFilial. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponsavelFilial() {
    return await Request.post(`/admin/responsavel-filial`, this)
      .name('persistResponsavelFilial')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelFilial to use it in a CSV file
   */
  static async listCsvResponsavelFilial(params: any) {
    return await Request.get(`/admin/responsavel-filial/csv`, {params})
      .name('listCsvResponsavelFilial')
      .as(ResponsavelFilialCollection)
      .getData()
  }
}
